import axios from 'axios';
import { BridgeAPI } from '../bridge';

const APIServer = process.env.VUE_APP_API_SERVER;

const API = {
  state: {
    gold: 0,
    goldHistory: [],
    goldHistoryCount: 0,
    goldHistoryLoading: false,
    ordersLoading: false,
    orders: [],
  },
  getters: {
    gold: state => state.gold,
    goldHistory: state => state.goldHistory,
    goldHistoryCount: state => state.goldHistoryCount,
    goldHistoryLoading: state => state.goldHistoryLoading,
    
    ordersLoading: state => state.ordersLoading,
    orders: state => state.orders,
  },
  mutations: {
    setGold: (state, amount) => state.gold = amount,
    setGoldHistory: (state, history) => {
      state.goldHistory = history;
    },
    goldHistoryCount: (state, total) => {
      state.goldHistoryCount = total
    },
    setGoldHistoryLoading: state => state.goldHistoryLoading = true,
    setGoldHistoryNotLoading: state => state.goldHistoryLoading = false,

    setOrders: (state, orders) => state.orders = orders,
    setOrdersLoading: state => state.ordersLoading = true,
    setOrdersNotLoading: state => state.ordersLoading = false,
  },
  actions: {
    setGold: ({ commit }, amount) => commit('setGold', amount),
    setGoldHistoryLoading: ({ commit }) => commit('setGoldHistoryLoading'),
    setGoldHistoryNotLoading: ({ commit }) => commit('setGoldHistoryNotLoading'),

    fetchOrders: async ({ commit }) => {
      commit('setAppLoading');
      const installId = await BridgeAPI.getInstallId();
      if (installId) {
        let req = {
          method: 'GET',
          url: `${APIServer}/${installId}/orders`,
          withCredentials: true,
        };
        commit('setOrdersLoading');
        
        const resp = await axios.request(req).catch(() => false);
        if (resp && resp.status === 200) {
          if (resp.data && resp.data.orders) {
            commit('setOrders', resp.data.orders);
          }
        }
        commit('setOrdersNotLoading');
        // commit('unsetAppLoading');
      }
    },

    /**
     * Get the gold history for this install
     */
    fetchGoldHistory: async ({ commit }, page = 0) => {
      commit('setAppLoading');
      const installId = await BridgeAPI.getInstallId();
      if (installId) {

        let req = {
          method: 'GET',
          url: `${APIServer}/${installId}/gold/history`,
          withCredentials: true,
        };
        if (page > 0) {
          req.params = {
            page: page
          }
        }
        commit('setGoldHistoryLoading');
        const resp = await axios.request(req).catch(() => false);
        if (resp && resp.status === 200) {
          if (resp.data && resp.data.success) {
            commit('setGoldHistory', resp.data.gold_history);
            commit('goldHistoryCount', resp.data.total);
          }
        }
        commit('setGoldHistoryNotLoading');
      }
      // commit('unsetAppLoading');
    },

    /**
     * Get the current gold for this install
     */
    fetchGold: async ({ commit }) => {
      commit('setAppLoading');
      const installId = await BridgeAPI.getInstallId();
      if (installId) {
        const ts = new Date().getTime();
        let req = {
          method: 'GET',
          url: `${APIServer}/${installId}/gold?ts=${ts}`, // intentionally have a typo here to make it fail
          withCredentials: true,
        };

        const resp = await axios.request(req).catch((err) => {
          console.error(err); // eslint-disable-line
          return false;
        });
        
        if (resp === false) {
          throw new Error('Unable to fetch Gold');
        }

        if (resp && resp.status === 200) {
          if (resp.data && resp.data.success && resp.data.gold !== undefined && resp.data.gold !== null) {
            commit('setGold', resp.data.gold);
            return;
          }
        }

        throw new Error('Unable to fetch Gold');
      }
      commit('unsetAppLoading');
    },

    createOrder: async ({ dispatch }, order) => {
      const installId = await BridgeAPI.getInstallId();
      return new Promise(async (resolve, reject) => {
        let error = 'An error occurred while submitting your order.';
        if (installId) {
          const resp = await axios.request({
            method: 'POST',
            url: `${APIServer}/${installId}/orders/add`,
            withCredentials: true,
            data: {
              target: order.target,
              amount: order.amount,
              before: order.before || 0,
              user_id: order.user_id,
              post_id: order.post_id,
            },
            responseType: 'json',
            timeout: 10000,
          }).catch(err => {
            if (err.response && err.response.data && err.response.data.message) {
              error = err.response.data.message;
            } else {
              error = 'An error occurred while submitting your order. 343333';
            }
            // reject(error);
            return err.response;
          });

          if (resp.status === 200) {
            if (resp.data) {
              if (resp.data.message && resp.data.message.length) {
                return reject(resp.data.message);
              } else if (resp.data.success === true) {
                dispatch('fetchGold');
                return resolve(true);
              } else {
                return reject(error);
              }
            } else {
              return reject(new Error('No response data was found.'));
            }
          } else {
            return reject(new Error(`Status code was not okay ${resp.status}`));
          }
        }
        return reject(error);
      });
    },
  },
}

export {
  API
}